import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class MarketingTeamGuard implements CanActivate {
  constructor(
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = this.storageService.get('user_details');
    // if (user.role.group.category == 4 && user.is_afa == true) {
      const redirectUrl = state.url;
      if (user) {
        if ((user.role.role == 11)) {
          return true;
        }
        
        // Redirect to home page or an error page
        this.authService.setReturnUrl(redirectUrl);
        this.router.navigate(['/login']);
        // this.authService.logout();
        return false;
      } else {
        this.authService.setReturnUrl(redirectUrl);
        this.router.navigate(['/login']);
        // this.authService.logout();
        return false;
      }

    // Redirect to home page or an error page
    // this.router.navigate(['/login']);
    // this.authService.logout();
    // return false;
  }
}
